import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import AddEmployeeModal from 'modules/locations/components/AddEmployee'

const AddEmployeeModalPage = () => {
  const { navigation } = useNavigation()
  const { id } = useStrictParams<'id'>()
  const navigate = useNavigate()

  const onClose = () => {
    navigate(navigation.settings.locations.locationsId.employees.fullPath({ id }))
  }

  return <AddEmployeeModal locationId={id} onClose={onClose} />
}

export default AddEmployeeModalPage
